import {getUser} from "@project/sdk/admin";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../shared/query/query-policies";
import {userKeys} from "../../user-keys";

import {userResponseSchema} from "./get-user.schema";

/**
 * Query options factory for a single user detail.
 *
 * Usage in a route loader:
 *   queryClient.ensureQueryData(getUserQueryOptions(params.userId))
 *
 * Usage in a component:
 *   const { data: user } = useSuspenseQuery(getUserQueryOptions(userId));
 *
 * Throws if the user is not found — the route's errorComponent will handle it.
 */
export function getUserQueryOptions(id: string) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    queryFn: async () => {
      const data = await getUser(id);

      return userResponseSchema.parse(data);
    },
    queryKey: userKeys.detail(id),
  });
}
